import mixins from 'vue-typed-mixins';

import UserStamp from '@/user/components/userStamp/UserStamp.vue';
import { Grayout } from '@/user/components/userStamp/UserStamp';

import UnitSelectMixin from '@/user/mixins/UnitSelectMixin';

import StorageUtility from '@/classes/common/StorageUtility';
import { USER_STORAGE_KEY } from '@/classes/common/Constants';
import SectionData from '@/classes/data/SectionData';




type Cell = {
  section: SectionData;
  grayout: Grayout;
};

export default mixins(UnitSelectMixin).extend({

  name: 'UnitSelectJapanese',

  components: {
    UserStamp,
  },

  data(): {
    readonly maxSectionsPerRow: number;
    table: Cell[][];
    visibleDialog: boolean;
    selectedSection: SectionData | null;
  } {
    return {
      maxSectionsPerRow: 10,
      table: [],
      visibleDialog: false,
      selectedSection: null,
    };
  },

  computed: {
    title(): string {
      if (this.selectedSection === null) return '';
      return `${this.selectedSection.sectionNo}. ${this.selectedSection.sectionName}`;
    },
    subTitle(): string {
      if (this.selectedSection === null) return '';
      const author   = this.selectedSection.author;
      const category = this.selectedSection.category;
      return author.length === 0 || category.length === 0 ? author + category : `${author} / ${category}`;
    },
  },

  async created(): Promise<void> {
    // 進度読み込み
    await this.loadProgressesState(this.courseId);

    this.$_initializeTable();
  },

  methods: {
    unitIcon(section: SectionData, unitNo: number): string {
      return this.isDoneUnit(section, unitNo) ? 'check' : 'times';
    },
    openDialog(section: SectionData): void {
      this.selectedSection = section;
      this.visibleDialog = true;
    },
    // UnitSelectMixin を上書き
    toStudy(sectionNo: number, unitNo: number): void {
      // 選択した単元Noを保持
      StorageUtility.setSessionData<number>(USER_STORAGE_KEY.STUDY_SECTION_NO, sectionNo);

      this.$router.push({
        name: this.routes.Study.name,
        params: this.$route.params,
        query: {
          sectionNo: String(sectionNo),
          unitNo:    String(unitNo),
        },
      });
    },
    $_initializeTable(): void {
      // 学習から戻った場合にダイアログを再表示するための変数
      const studySectionNo = StorageUtility.getSessionData<number>(USER_STORAGE_KEY.STUDY_SECTION_NO);
      let visibleDialogSection = null;

      // テーブルの初期化
      this.table = [];
      let row: Cell[] = [];
      this.sections.forEach(section => {
        let grayout = Grayout.None;
        const progress    = this.progresses.find(p => p.sectionNo === section.sectionNo);
        const unitNoCount = progress?.unitNos.length ?? 0;
        if      (unitNoCount === 0)               grayout = Grayout.Full;
        else if (unitNoCount < section.unitCount) grayout = Grayout.Half;
        row.push({
          section,
          grayout
        });

        // セッションストレージの学習単元Noと一致、かつ完了していない単元の場合は単元情報を保持
        if (section.sectionNo === studySectionNo && grayout !== Grayout.None) {
          visibleDialogSection = section;
        }

        if (row.length === this.maxSectionsPerRow) {
          this.table.push(row);
          row = [];
        }
      });

      // ダイアログ再表示情報がある場合はダイアログ表示
      if (visibleDialogSection !== null) this.openDialog(visibleDialogSection);
    },
  },

});
